module.exports = __webpack_public_path__ + "img/8.e8752cf8.png";